import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  // user_id + datatable
  GET_DISCOUNTS: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/discounts/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  /*
    percentage: float
    from_date: datetime
    to_date: datetime
    user_id: Optional[int]
    product_id: Optional[int]
  */
  CREATE_DISCOUNT: ({ commit, dispatch }, discount) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/discounts`, discount).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  /*
    percentage: Optional[float]
    from_date: Optional[datetime]
    to_date: Optional[datetime]
    user_id: Optional[int]
    product_id: Optional[int]
  */
  EDIT_DISCOUNT: ({ commit, dispatch }, {discountId, discount}) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/discounts/` + discountId, discount).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  ACTIVATE_DISCOUNT: ({ commit, dispatch }, discountId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/discounts/${discountId}/activate`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_DISCOUNT: ({ commit, dispatch }, discountId) => {
    return new Promise((resolve, reject) => {
      Vue.http.delete(`${apiUrl}${version}/discounts/${discountId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/discount/actions.js